// Servicio para manejar operaciones de imports (planillas) con la base de datos
import { environment } from '../config/environment';

class ImportService {
  constructor() {
    this.baseUrl = environment.apiBaseUrl;
  }

  // Obtener todas las planillas importadas
  async getAllImports(filters = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.contest_id) queryParams.append('contest_id', filters.contest_id);
      if (filters.organizer_id) queryParams.append('organizer_id', filters.organizer_id);
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.source_type) queryParams.append('source_type', filters.source_type);
      
      const queryString = queryParams.toString();
      const url = `${this.baseUrl}/imports${queryString ? `?${queryString}` : ''}`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const imports = await response.json();
      return imports;
    } catch (error) {
      console.error('Error fetching imports:', error);
      throw error;
    }
  }

  // Obtener una planilla por ID
  async getImportById(id) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${id}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const importData = await response.json();
      return importData;
    } catch (error) {
      console.error('Error fetching import:', error);
      throw error;
    }
  }

  // Crear un nuevo registro de importación
  async createImport(importData) {
    try {
      const response = await fetch(`${this.baseUrl}/imports`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(importData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating import:', error);
      throw error;
    }
  }

  // Actualizar un import
  async updateImport(id, updateData) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating import:', error);
      throw error;
    }
  }

  // Eliminar un import
  async deleteImport(id) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting import:', error);
      throw error;
    }
  }

  // Obtener mapeos de campos de una planilla
  async getFieldMappings(importId) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${importId}/mappings`);
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const mappings = await response.json();
      return mappings;
    } catch (error) {
      console.error('Error fetching field mappings:', error);
      throw error;
    }
  }

  // Crear un mapeo de campo
  async createFieldMapping(importId, mappingData) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${importId}/mappings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(mappingData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating field mapping:', error);
      throw error;
    }
  }

  // Actualizar un mapeo de campo
  async updateFieldMapping(importId, mappingId, updateData) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${importId}/mappings/${mappingId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating field mapping:', error);
      throw error;
    }
  }

  // Eliminar un mapeo de campo
  async deleteFieldMapping(importId, mappingId) {
    try {
      const response = await fetch(`${this.baseUrl}/imports/${importId}/mappings/${mappingId}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting field mapping:', error);
      throw error;
    }
  }
}

export default new ImportService();

